/**
 * Pure, DOM-free helpers for the Returns Analysis page's visual bars (Status,
 * Channel, Open Return Age). Kept separate from index.js so the "a zero
 * value must render a zero-width bar" rule is unit-testable without mounting
 * React.
 */

/**
 * Width (0-100) for a proportional bar. A literal zero value — or a zero/
 * invalid denominator (nothing to compare against, i.e. an effective 0/0) —
 * must render as an empty track, never a fabricated minimum sliver. Small
 * but genuinely non-zero values still get a floor so they stay visible.
 */
export const barWidthPercent = (value, max) => {
  const numericValue = Number(value) || 0;
  const numericMax = Number(max) || 0;
  if (numericValue <= 0 || numericMax <= 0) return 0;
  return Math.min(100, Math.max(2, Math.round((numericValue / numericMax) * 100)));
};

/** Largest positive value across a set of rows, or 0 when none are positive (safe divisor input). */
export const maxPositive = (values) => {
  const positive = (values || []).map((v) => Number(v) || 0).filter((v) => v > 0);
  return positive.length ? Math.max(...positive) : 0;
};
